document.addEventListener('DOMContentLoaded',()=>{
  const b=document.querySelector('[data-menu-toggle]'),n=document.querySelector('[data-nav]');
  if(b&&n)b.addEventListener('click',()=>{const o=n.classList.toggle('open');b.setAttribute('aria-expanded',o)});
  document.querySelectorAll('[data-nav] a').forEach(a=>a.addEventListener('click',()=>n&&n.classList.remove('open')));
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting)e.target.classList.add('visible')}),{threshold:.12});
  document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

  const storyButton=document.querySelector('[data-full-story-toggle]');
  const storyPanel=document.querySelector('[data-full-story]');
  if(storyButton&&storyPanel){
    storyButton.addEventListener('click',()=>{
      const isOpening=storyPanel.hasAttribute('hidden');
      if(isOpening){
        storyPanel.removeAttribute('hidden');
        storyButton.setAttribute('aria-expanded','true');
        storyButton.textContent='Close My Story';
        window.setTimeout(()=>storyPanel.scrollIntoView({behavior:'smooth',block:'start'}),40);
      }else{
        storyPanel.setAttribute('hidden','');
        storyButton.setAttribute('aria-expanded','false');
        storyButton.textContent=storyButton.dataset.originalText||'More About Me';
      }
    });
    storyButton.dataset.originalText=storyButton.textContent.trim();
  }
});
